import * as react_components from "../reactcomponent.js"
import React from "react";
interface DropDownListProps {
    valueField?: string;
    keyField?: string;
    onChange?: any;
    value?: any;
    width?: any;
    label?: string;
    data?: any
}

export class DropDownList extends React.Component<DropDownListProps, any>{
    private dropDownList: any;
    constructor(props) {
        super(props);
        this.state = { page: 0, isLoading: false };
    }

    getData = () => {
        if (typeof (this.props.data) !== 'undefined') {
            this.setState({ values: this.props.data });
        }
    }

    componentDidMount() {
        var that = this;
        var $rootNode = $(this.refs.dropDownList);

        var list = $rootNode.kendoDropDownList({
            dataTextField: this.props.valueField,
            dataValueField: this.props.keyField,
            change: function () {
                var value = this.value();
                that.props.onChange(value);
            }
        });
        this.dropDownList = list.data("kendoDropDownList");
        this.getData();
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.state.values !== prevState.values) {
            this.dropDownList.dataSource.data(this.state.values);
        }

        if (Array.isArray(this.props.value)) {
            this.dropDownList.value(this.props.value.slice());

        }
        else {
            this.dropDownList.value([this.props.value]);
        }

        if (this.props.data !== prevProps.data) {
            this.getData();
        }
    }

    render() {
        var style = { width: "100%" };
        if (this.state.isLoading) {
            var spinner = <img src="Content/img/spinner.gif" />
        }
        return (<react_components.ReactColumn width={this.props.width}>
            <div className="form-group">
                <label>{this.props.label}</label> {spinner}
                <input ref="dropDownList" style={style} value={this.props.value}></input>
            </div>
        </react_components.ReactColumn>)
    }
};